import React from 'react';
import { CaretLeft, CaretRight } from 'phosphor-react';
import { ContinueButton } from './ContinueButton';

const backBase =
  'flex-1 flex items-center justify-center gap-1.5 py-2.5 px-4 rounded-[10px] text-sm font-semibold text-[var(--text-primary)] cursor-pointer transition-all duration-300 border-2 [&_svg]:w-[18px] [&_svg]:h-[18px] max-md:py-2.5 max-md:px-3 max-md:text-[13px] max-md:min-h-[40px] max-md:[&_svg]:w-4 max-md:[&_svg]:h-4';

const backVariants = {
  default:
    'bg-[var(--card-bg)] border-[rgba(29,71,70,0.15)] shadow-[0_2px_4px_rgba(29,71,70,0.08)] hover:bg-[var(--bg-hover)] hover:border-[rgba(29,71,70,0.3)] hover:-translate-y-px hover:shadow-[0_4px_8px_rgba(29,71,70,0.12)] dark:bg-white/10 dark:border-white/15 dark:shadow-[0_2px_4px_rgba(0,0,0,0.2)] dark:hover:bg-white/20 dark:hover:border-white/25 dark:hover:shadow-[0_4px_8px_rgba(0,0,0,0.3)]',
  drill:
    'bg-[var(--card-bg)] border-[rgba(30,61,111,0.15)] shadow-[0_2px_4px_rgba(30,61,111,0.08)] hover:bg-[var(--bg-hover)] hover:border-[rgba(30,61,111,0.3)] hover:-translate-y-px hover:shadow-[0_4px_8px_rgba(30,61,111,0.12)] dark:bg-white/10 dark:border-[rgba(30,61,111,0.25)] dark:shadow-[0_2px_4px_rgba(30,61,111,0.15)] dark:hover:bg-white/20 dark:hover:border-[rgba(30,61,111,0.4)] dark:hover:shadow-[0_4px_8px_rgba(30,61,111,0.2)]',
};

const reviewBase =
  'w-full flex items-center justify-center gap-2 py-3 px-4 rounded-[10px] text-sm font-semibold text-white cursor-pointer transition-all duration-300 border-2 [&_svg]:w-[18px] [&_svg]:h-[18px] max-md:py-2.5 max-md:px-3 max-md:text-[13px] max-md:min-h-[40px] max-md:[&_svg]:w-4 max-md:[&_svg]:h-4';

const reviewVariants = {
  default:
    'bg-gradient-to-br from-[#12766d] via-[#236463] to-[#1d4746] border-[rgba(18,118,109,0.45)] shadow-[0_2px_6px_rgba(18,118,109,0.25)] hover:from-[#236463] hover:via-[#1d4746] hover:to-[#163b3a] hover:border-[rgba(18,118,109,0.65)] hover:-translate-y-px hover:shadow-[0_4px_10px_rgba(18,118,109,0.35)] dark:bg-white/10 dark:border-white/15 dark:shadow-[0_2px_4px_rgba(0,0,0,0.2)] dark:hover:bg-white/20 dark:hover:border-white/25 dark:hover:shadow-[0_4px_8px_rgba(0,0,0,0.3)]',
  drill:
    'bg-gradient-to-br from-[#1e3d6f] via-[#345d8a] to-[#4a6fa5] border-[rgba(30,61,111,0.5)] shadow-[0_2px_6px_rgba(30,61,111,0.25)] hover:from-[#345d8a] hover:via-[#4a6fa5] hover:to-[#5b7eb0] hover:border-[rgba(30,61,111,0.65)] hover:-translate-y-px hover:shadow-[0_4px_10px_rgba(30,61,111,0.35)] dark:bg-white/10 dark:border-white/15 dark:shadow-[0_2px_4px_rgba(0,0,0,0.2)] dark:hover:bg-white/20 dark:hover:border-white/25 dark:hover:shadow-[0_4px_8px_rgba(0,0,0,0.3)]',
};

/**
 * Result action buttons with 2-row layout:
 * Row 1: [Back | Continue] side by side
 * Row 2: [Review] full width
 */
export function ResultActions({ onBack, onContinue, onReview, isDrillVocab = false }) {
  const v = isDrillVocab ? 'drill' : 'default';
  return (
    <div className="w-full max-w-[420px] flex flex-col gap-2.5 mt-1 pt-1 mx-auto max-md:gap-2">
      <div className="flex items-center gap-2.5 w-full max-md:gap-2">
        <button
          type="button"
          onClick={onBack}
          className={`${backBase} ${backVariants[v]}`}
          aria-label="Back"
        >
          <CaretLeft size={18} weight="bold" />
          <span>Back</span>
        </button>
        <ContinueButton onClick={onContinue} variant={v}>Continue</ContinueButton>
      </div>
      <button
        type="button"
        onClick={onReview}
        className={`${reviewBase} ${reviewVariants[v]}`}
        aria-label="Lihat Pembahasan"
      >
        <span>Lihat Pembahasan</span>
        <CaretRight size={18} weight="bold" />
      </button>
    </div>
  );
}
